import {jsonMember, jsonObject} from "typedjson";

/** Опций бесконечного скролирования. */
@jsonObject
export class  DxInfiniteScrollOptions {
  /** Размер блока данных, который фетчится при скролировании. */
  @jsonMember({name: "initialRowCount", constructor: Number, emitDefaultValue: false, isRequired: false})
  private _initialRowCount: number = 100;

  /** Сколько блоков данных держать в кэше. */
  @jsonMember({name: "maxBlocksInCache", constructor: Number, emitDefaultValue: false, isRequired: false})
  private _maxBlocksInCache: number = 2;

  get initialRowCount(): number {
    return this._initialRowCount;
  }

  set initialRowCount(value: number) {
    this._initialRowCount = value;
  }

  get maxBlocksInCache(): number {
    return this._maxBlocksInCache;
  }

  set maxBlocksInCache(value: number) {
    this._maxBlocksInCache = value;
  }
}
